// extracted by mini-css-extract-plugin
module.exports = {"account":"AccountPage_account__26W6-"};